<template>
  <PivotFields v-if="config?.open">
    <PivotFieldsSections
      v-model="config"
      :readonly
      :disable-cols
    />
  </PivotFields>
</template>

<script setup lang="ts">
import { PivotTableConfig } from '@types'

import PivotFieldsSections from './PivotFieldsSections.vue'
import PivotFields from './primitives/PivotFields.vue'

interface PivotFieldsPanelProps {
  readonly?: boolean
  disableCols?: boolean
}

defineProps<PivotFieldsPanelProps>()

const config = defineModel<PivotTableConfig>('config')
</script>
